module.exports = __webpack_public_path__ + "img/aeroland_slider-sass-image-03.adbb2c90.png";